export function formatCurrency(amount, currency = 'INR') {
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) {
    return '₹0';
  }
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numAmount);
}

export function formatNumber(value) {
  return (Number(value) || 0).toLocaleString('en-IN');
}

// GST charged on top of plan prices (must match backend GST_RATE)
export const GST_RATE = 18;

export function calculateGst(amount) {
  const subtotal = Math.round((parseFloat(amount) || 0) * 100) / 100;
  const gst = Math.round(subtotal * GST_RATE) / 100;
  return { subtotal, gst, total: Math.round((subtotal + gst) * 100) / 100 };
}

export function formatDate(date, options = {}) {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return 'N/A';
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  return parsedDate.toLocaleDateString('en-US', { ...defaultOptions, ...options });
}

export function formatDateTime(date) {
  if (!date) return 'N/A';
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return 'N/A';
  return parsedDate.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelativeTime(date) {
  if (!date) return 'N/A';
  const now = new Date();
  const then = new Date(date);
  if (isNaN(then.getTime())) return 'N/A';
  const diffMs = now - then;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
  return `${Math.floor(diffDays / 365)} years ago`;
}

export function getDaysRemaining(endDate) {
  if (!endDate) return 0;
  const now = new Date();
  const end = new Date(endDate);
  if (isNaN(end.getTime())) return 0;
  const diffMs = end - now;
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function debounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

export function generateId() {
  return Math.random().toString(36).substr(2, 9);
}
